import React from "react";
import TodoList from "./TodoList";

const App = () => {
  return (
    <>
      <div className="main-container">
        <TodoList />
      </div>
    </>
  );
};

export default App;

